import { useState, useEffect } from "react";
import { fetchTaskDetail } from "../../models/shared/taskDetailModel";
import { fetchSrmUsers } from "../../models/shared/agentsUsersModel";
import { fetchCostPrices } from "../../models/shared/costPricesModel";

export function useQuoteApprovalContext({ open, payload }) {
  const [costPrices, setCostPrices] = useState([]);
  const [policyLoading, setPolicyLoading] = useState(true);
  const [fullTask, setFullTask] = useState(null);
  const [fullTaskLoading, setFullTaskLoading] = useState(false);
  const [userMap, setUserMap] = useState({});
  // Full query context (vehicle, customer, timeline) for the admin to
  // reference before approving — this isn't part of the approval payload
  // itself, so it's fetched separately from the same endpoint the task
  // drawer uses.
  useEffect(() => {
    if (!open || (!payload.query_pk && !payload.query_id)) { setFullTask(null); return; }
    setFullTaskLoading(true);
    fetchTaskDetail(payload.query_pk ?? payload.query_id)
      .then(result => { if (result) setFullTask(result); })
      .catch(() => setFullTask(null))
      .finally(() => setFullTaskLoading(false));
  }, [open, payload.query_pk, payload.query_id]); // eslint-disable-line

  useEffect(() => {
    if (!open) return;
    fetchSrmUsers().then(list => {
      const map = {};
      list.forEach(u => { map[u.id] = u.fullName; });
      setUserMap(map);
    });
  }, [open]);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setPolicyLoading(true);
    fetchCostPrices({ force: true }).then(rows => {
      if (!cancelled) { setCostPrices(rows); setPolicyLoading(false); }
    });
    return () => { cancelled = true; };
  }, [open]);


  return { costPrices, policyLoading, fullTask, setFullTask, fullTaskLoading, userMap };
}
